export const LOCAL_DOMAIN = '127.0.0.1';
export const REMOTE_DOMAIN = 'quirion.de';
